import { node } from "~/util/dom";
import { CONFIG } from "~/config";

interface ISEARCH_TYPE {
	[key: string]: string;
}

export interface ICanonical {
	set: (path: string, search: ISEARCH_TYPE) => void;
	get: () => string;
	remove: () => void;
	setByPage: () => void;
}

const SEARCH_SKIP = ["x", "y", "z"];
const PANO_3D = ["m3d", "pano"];
const origPathName = location.pathname;
let canonicalLink: HTMLLinkElement = null;

/**
 * Nastav kanonickou url - vezme akt. protokol a url mapy,
 * prida cestu a search parametry
 *
 * @param {String} path
 * @param {Object} [search] Object pro search cast
 */
function set(path = "/", search:ISEARCH_TYPE = {}) {
	let url = `${location.protocol}//${CONFIG.BASE_URL}${path}`;

	// prepsani lokalizovaneho parametru pocasi za weather (en)
	if (search.pocasi || search.pocasie || search.wetter) {
		search.weather = search.pocasi || search.pocasie || search.wetter;

		delete search.pocasi;
		delete search.pocasie;
		delete search.wetter;
	}

	const searchPart = new URLSearchParams(search).toString().replace("=null", "");

	if (searchPart) {
		url += `?${searchPart}`;
	}

	if (canonicalLink) {
		canonicalLink.setAttribute("href", url);
	} else {
		const item = node("link");

		item.setAttribute("rel", "canonical");
		item.setAttribute("href", url);

		document.getElementsByTagName("head")[0].appendChild(item);

		canonicalLink = item;
	}
}

/**
 * Aktualni hodnota.
 */
function get(): string {
	return canonicalLink ? canonicalLink.getAttribute("href") : "";
}

function remove() {
	if (canonicalLink) {
		canonicalLink.remove();
		canonicalLink = null;
	}
}

function setByPage() {
	// preskocime jiz nastaveny; nebo puvodni prazdny pathname
	if (get().length > 0 || origPathName === "/") {
		return;
	}

	const searchPart = Mapy.Util.searchToObj();
	let path = "/";
	let search:ISEARCH_TYPE = {};

	// preskocit argumenty z url search casti
	SEARCH_SKIP.forEach(item => {
		if (item in searchPart) {
			delete searchPart[item];
		}
	});

	if ("id" in searchPart && "source" in searchPart) { // 5 detail
		search.source = searchPart.source;
		search.id = searchPart.id;
	} else if ("mereni-vzdalenosti" in searchPart || "vlastni-body" in searchPart) { // 4 vsechny mereni
		search["mereni-vzdalenosti"] = null;
		search.rm = searchPart.rm;
	} else if ("cat" in searchPart && searchPart.cat === "mista-trasy" && "mid" in searchPart) { // 3 moje mapy
		search = {
			...search,
			cat: searchPart.cat,
			mid: searchPart.mid,
		};
	} else if ("planovani-trasy" in searchPart && !Mapy.CML.state.route.items.length) { // 3 moje mapy
		search["planovani-trasy"] = null;
	} else if ("q" in searchPart) { // 2 hledani
		search.q = searchPart.q;

		if ("cat" in searchPart) {
			search.cat = searchPart.cat;
		}
	} else if (Object.keys(searchPart).length) { // zbytek
		let seo = "";
		const spKeys = Object.keys(searchPart);

		spKeys.forEach(key => {
			// seo
			if (searchPart[key] === "") {
				seo = key;
			}
		});

		if (seo) {
			search[seo] = null;
		} else if (spKeys.length === 1) {
			search = searchPart;
		} else {
			let find = null;

			PANO_3D.every(item => {
				if (item in searchPart) {
					search[item] = searchPart[item];
					find = true;

					return false;
				}

				return true;
			});

			if (!find) {
				return;
			}
		}
	} else { // 1 podklady
		// bez search casti
		path = location.pathname;
	}

	set(path, search);
}

export default { set, get, remove, setByPage };
